import { render, staticRenderFns } from "./balance-add.vue?vue&type=template&id=d3264fac&scoped=true"
import script from "./balance-add.vue?vue&type=script&lang=js"
export * from "./balance-add.vue?vue&type=script&lang=js"
import style0 from "./balance-add.vue?vue&type=style&index=0&id=d3264fac&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3264fac",
  null
  
)

export default component.exports